<template>
  <div id="video_page_info">
    
    <div id="info_hero"  :style="'background-image:url(' + item.pic_hero_parsed + ')'">
      <div v-if="!is_user_can_watch">
        <div id="unactive_screen" >
        <div class="bg" :style="'background-image:url('+ item.pic_hero_parsed +')'"></div>

        <div class="inner">



          <div style="color:#dd1a7b;">
                    <router-link to="/"><i class="fas fa-arrow-circle-right"></i></router-link>

            <p>תוכן זה חסום לסוג המנוי שלך</p>
            <div>רוצה לצפות בכל התכנים בTOV?</div>
          
            <!-- <a class="btn" :href="'https://www.tov.tv/joinus/pay?token=' + user_token">סיימו את ההרשמה עכשיו</a> -->
            <a class="btn" @click="$emit('open_pay')"> הפכו לפרימיום</a>
          </div>

        </div>
      </div>
    </div>
     
                <router-link  :to="'/item/' + item.id " v-if="is_user_can_watch" class="play"><i class="fas fa-play-circle"></i>
                </router-link>
    </div>
    <div id="info_bar">
      <h1>{{ item.title }}</h1>
      <div class="top_btns">
        <label v-if="item.restricted === true" class="lbl_restricted">מוגבל</label>
        <router-link :to="'/item/' + item.id" class="btn" v-if="item.restricted != true"><i class="far fa-play-circle"></i>הפעל</router-link>
        <a class="btn" @click="add_to_fav(item.id)" v-if="item.restricted != true"><i class="far fa-star"></i>הוספה למועדפים</a>
      </div>



      <div id="info_menu">
        <a :class="(menu_selected == 'info' ? 'active' : '')" @click="menu_selected = 'info'">סקירה כללית</a>
        <a :class="(menu_selected == 'trailers' ? 'active' : '')" @click="menu_selected = 'trailers'" v-text="(item.type == 'series' ? 'טריילרים ופרקים' : 'טריילר ועוד')"></a>
        <a :class="(menu_selected == 'restrictions' ? 'active' : '')" @click="menu_selected = 'restrictions'">הגבלות צפיה TOV</a>
      </div>

    <div id="info_content_info" v-if="menu_selected == 'info'">
      <div style="margin-bottom:13px;">
          <b><span v-if="!isNull(item.main_category)" v-text="item.main_category.name"></span> |  {{item.year}} | <span v-if="item.age_parsed > 0" class="age_restriction">{{item.age_parsed}}+</span></b>
      </div>
      <div>

          <h4>תקציר</h4>
          <div class="content">{{ item.full_description }}</div>
          <div v-if="item.actors != ''">
            <h4>שחקנים</h4>
            <div class="content">{{ item.actors }}</div>
          </div>
      </div>
      <h3 class="title">בגלל שהתעניינת ב{{ item.title }}</h3>


      <div v-for="episode_item in item.rel_items" class="col-md-6 col-xs-6" :key="episode_item.id">
        <itemTpl :item="episode_item" />
      </div>

      
    </div>


    <div id="episodes_bar" v-if="menu_selected == 'trailers'">
     
      <div class="episodes container" v-scroll-spy>
           
        <div v-for="season in seasons" :key="season.id" class="section">
          <h3 class="title">עונה {{ season.num }}</h3>
           
          <div class="episode" v-for="episode_item in season.episodes" :key="episode_item.id" :class="(episode_item.id == episode.id ? 'active' : '')">
            <i :class="'fas ' + (episode_item.is_premium == 1 ? 'fa-lock' : 'fa-lock-open')" v-if="!is_user_can_watch"></i>
            <router-link  :to="'/item/' + item.id + '/' + episode_item.id + '?is_episodes_bar_opened=false'"  >
              <div class="pic" :style="'background-image:url(' + episode_item.pic_thumb_parsed + ')'">
                <div class="user_duration"><span :style="'width:' + episode_item.user_duration_perc + '%'"></span></div>
              </div>
            <div class="content">
              <div v-if="episode_item.video == '' " class="soon">בקרוב</div>
              <h3>{{ episode_item.title }}</h3>
              <h4>{{ episode_item.description }}</h4>
            </div>
            
            </router-link>
            
          </div>

        </div>
      </div>
    </div>


    <div id="info_content_restrictions" v-if="menu_selected == 'restrictions'">
      
          <div class="content">{{ item.rest_description }}</div>
                      <h3 v-if="item.rest_description ==''">  אין הגבלות צפייה </h3>

      <div v-for="season_item in seasons" :key="season_item.id">
        <div v-for="episode_item in season_item.episodes" :key="episode_item.id">
          <div v-for="rest_cat in episode_item.restrictions" :key="rest_cat.id">
            <h3 v-text="rest_cat.data.name"></h3>
            <table>
              <thead><tr><th>דלג</th><th v-if="item.type == 'series'">פרק</th><th>דקה</th><th>תיאור</th></tr></thead>
              <tbody>
                <tr v-for="(rest_item, index) in rest_cat.items" :key="rest_item.id">
                  <td><input type="checkbox" v-model="rest_item.is_checked" :key="index" @change="rest_change(rest_item.id, $event)"></td>
                  <td v-if="item.type == 'series'">עונה {{ season_item.num }} - {{ episode_item.title }}</td>
                  <td>{{ rest_item.time_start }} - {{ rest_item.time_end }}</td>
                  <td>{{ rest_item.description }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>

    </div>


  </div>
</template>

<script>

import itemTpl from './item_tpl.vue'


export default {
  components: { itemTpl },
 
  props: {
      options: {
          type: Object,
          default() {
              return {};
          }
      }
  },
  data() {
    return {
      id: this.$route.params.id,
      eid: this.$route.params.eid,
      episode: {},
      seasons: [],
      item: {},
      cur_season: {},
      next_episode: {},
      menu_selected: 'trailers'
    };
  },
  methods: {
    rest_change(id, e)
    {
      this.user_restrictions[id] = e.target.checked;
      localStorage.setItem('user_restrictions', JSON.stringify(this.user_restrictions));
    }
  },


  created() {

    var self = this;
    // promoted
    this.api_call({ url: 'items/get', data: { id: this.id, eid: this.eid, parse_extended: true }, onComplete: function(data){

      self.seasons = data.data.data.seasons;
      self.cur_season = self.seasons[0];
      self.item = data.data.data;
      self.episode = data.data.data.episode;

      if (localStorage.getItem('user_restrictions') === null) localStorage.setItem('user_restrictions', JSON.stringify({}));

      self.user_restrictions = JSON.parse(localStorage.getItem('user_restrictions'));

      for (let season_i in self.seasons)
      {
        for(let episode_i in self.seasons[season_i].episodes)
        {
          for(let rest_cat_i in self.seasons[season_i].episodes[episode_i].restrictions)
          {
            for(let rest_i in self.seasons[season_i].episodes[episode_i].restrictions[rest_cat_i].items)
            {
              self.seasons[season_i].episodes[episode_i].restrictions[rest_cat_i].items[rest_i].is_checked = (self.user_restrictions[self.seasons[season_i].episodes[episode_i].restrictions[rest_cat_i].items[rest_i].id] === true ? true : false);
            }
          }
        }
      }


    }});
    
  },
    computed:{
is_user_can_watch(){
      if (this.episode.is_premium == '0') return true;

      if (this.get_me.is_active == true ) return true;

      return false;
    },
  },
}
</script>

<style lang="scss">

.container { position: relative; height: 400px; overflow: auto; }
#info_hero{
&{position: relative;}
#unactive_screen .fa-arrow-circle-right{position: absolute;top: 10px; right: 10px;}
#unactive_screen{margin: 0 auto;width: fit-content;
    padding: 30px;
    margin-top: 100px;
    text-align: center;
    font-size: 25px;
    position: absolute;
    top: 100px;
    box-shadow: 0 0 9px;
    left: 370px;
    border-radius: 15px;
    /* right: 0; */
    background: #000;}
}
.play{font-size: 70px;color: #dd1a7b;position: absolute;top: 50%;right: 50%;cursor: pointer;}
</style>
